module.exports = __webpack_public_path__ + "static/media/vocab_icon.fec26a28.png";